import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ResourceService } from './resource.service';
import { Observable } from 'rxjs';
import { GlobalSettings } from '../model/settings.model';
import { AuthenticationService } from './auth.service';
import { UsersPolicyModel } from '../model/users-policy.model';
import { AttributeModel } from '../main/dynamic/model/attribute.model';

@Injectable({
  providedIn: 'root'
})
export class UsersPolicyService extends ResourceService<UsersPolicyModel> {

  constructor(
    http: HttpClient,
    settings: GlobalSettings,
    authService: AuthenticationService) {
    super(http, "policies/Users", settings.politicasUrl, authService)
  }

  getPolicy(): Observable<UsersPolicyModel> {
    return this.get()
        .pipe(
            map((model) => model[0])
        )
  }

  setPolicy(body): Observable<UsersPolicyModel> {
    return this.create(body);
  }

  getPolicyByKey(key : string): Observable<Array<AttributeModel>> {
    return this.getWithComplement<AttributeModel[]>(`${key}`)
  }
}
